import { TSpaceResponseData } from 'typings';
import { homeSecurityPortalApi } from 'data/axios';
import { ApiResponse } from './HttpRequest';
import { ATLAS_ENDPOINTS } from './endpoints';

export async function GetAllSpaces(): Promise<
  ApiResponse<TSpaceResponseData[]>
> {
  const response = await homeSecurityPortalApi.get(ATLAS_ENDPOINTS.SPACE);
  console.log('GetAllSpaces', response);
  return response;
}
